import React from 'react';

import DetailItemView from '../../views/items/DetailItemView.js';
import WriteReviewModal from '../../views/items/modal/WriteReviewModal.js';
import LoadingModal from '../../views/global/LoadingModal.js';
import * as Auth from '../../services/Auth.Service.js';
import * as Items from '../../services/Items.Service.js';
import * as Reviews from '../../services/Reviews.Service.js';

import moment from 'moment';
import $ from 'jquery';

export class DetailItemComponent extends React.Component {


	/**
	 * Class constructor.
	 * @argument {object} props
	 */
	
	constructor(props) {
		

		super(props);

		this.state = {
			itemID: '',
			item: '',
			reviews: [],
			userActivity: [],
			reviews_options: [
				{ label: 'All', value: 'all'},
				{ label: 'Faves', value: 'up_fave'},
				{ label: 'Disfaves', value: 'down_fave'},
				{ label: 'Newest', value: 'newest'},
				{ label: 'Oldest', value: 'oldest'}
			],
			filter_review: [
				{label: 'All', id: 'all' }
			],
			show_write_review_modal: false,
			show_loading_modal: false,
			messages: {
				activity: '',
				review: ''

			},
			select_review: 'all',
			btn_list: [],
			isLoading: false,			
			detail_labels: []
		};
		this.getItem = this.getItem.bind(this);
		this.getReviews = this.getReviews.bind(this);
		this.readMore = this.readMore.bind(this);
		this.readLess = this.readLess.bind(this);
		this.getUserActivity = this.getUserActivity.bind(this);
		this.onChange = this.onChange.bind(this);
		this.toggleWriteReviewModal = this.toggleWriteReviewModal.bind(this);
		this.toggleLoadingModal = this.toggleLoadingModal.bind(this);
		this.onChangeSelect = this.onChangeSelect.bind(this);
	}

	componentWillMount() {
		const customStyles = {
			option: (provided, state) => ({
				...provided,			
				background: state.isFocused ? 'rgba(255, 255, 255, 0.10)' : '',
				backgroundColor: state.isSelected ? 'rgba(67, 67, 69, 0.50)' : '',
			}),
			control: provided => ({ 
				...provided, 
				backgroundColor: 'rgba(0, 0, 0, 0.40)', 
				borderRadius: '100px', 
				border: 'hidden',
				paddingLeft: '20px',
			}),
			menu: (provided, state) => ({
				...provided,
				borderBottom: '1px dotted pink',
				color: 'rgba(255, 255, 255, 0.60)',
				background: '#212121'
			}),
			singleValue: (provided) => ({
				...provided,
				color: 'white'
			}),
		}

		let itemID= this.props.match.params.id;
		this.setState({
			itemID: itemID,
			customStyles
		});		
		this.getItem(itemID);
		this.getUserActivity(itemID)
		this.getReviews(itemID);
	}

	componentDidUpdate(){
		/*let offsetHeight = document.getElementById('description-ellipsis').offsetHeight;
		let scrollHeight = document.getElementById('description-ellipsis').scrollHeight;
		document.getElementById('div-complete').style.display = 'none';	

		if (offsetHeight < scrollHeight){		
			document.getElementById('description-ellipsis').style.cursor = 'pointer';
			document.getElementById('description-complete').style.cursor = 'pointer';
			document.getElementById('link-ellipsis').style.cursor = 'pointer';
			document.getElementById('link-complete').style.cursor = 'pointer';
			document.getElementById('link-ellipsis').style.display = 'inline';	
			document.getElementById('link-complete').style.display = 'inline';	
		}else{					
			document.getElementById('description-ellipsis').style.cursor = 'default';
		}*/
	}

	onChangeSelect(obj){
		let select_review = obj.target.value;
		this.setState({
			select_review,
			isLoading: true
		});
		this.getReviews(this.state.itemID, select_review);
		//this.toggleLoadingModal(true);
	}

	onChange(event) {		
		let filter_review = this.state.filter_review;
		filter_review.label = event.label;
		filter_review.id = event.value;

		this.setState({
			filter_review,
			isLoading: true
		});
		this.getReviews(this.state.itemID, filter_review.id);
		//this.toggleLoadingModal(true);
	}

	getItem(id){

		Items.GetItem(id)
			.onSuccess(
				function (data) {	
					let detail_labels = [];
					if(data.category_id.id == "1"){
						detail_labels = [
							{label: 'MPAA Rating', value: data.rating}, 
							{label: 'Genre', value: (data.genre_id != null) ? data.genre_id.name : ''},
							{label: 'Release Date', value: (data.release_date_id != null) ? data.year : ''},
							{label: 'Studio', value: data.studio}
						];
						
					}else if(data.category_id.id == "2"){
						detail_labels = [
							{label: 'Genre', value: (data.genre_id != null) ? data.genre_id.name : ''},
							{label: 'Release Date', value: (data.release_date_id != null) ? data.year : ''},
							{label: 'Label', value: data.record_label}
						];

					}else if(data.category_id.id == "3"){
						let publisher = "";
						let ISBN = "";

						if(data.extras != null){
							let extras = data.extras;
							for (let i = 0; i < extras.length; i++) {
								if(extras[i].label == "Publisher"){
									publisher = extras[i].value
								}else if(extras[i].label == "ISBN"){
									ISBN = extras[i].value
								}													
							}
						}
						detail_labels = [
							{label: 'Genre', value: (data.genre_id != null) ? data.genre_id.name : ''},
							{label: 'Release Date', value: (data.release_date_id != null) ? data.year : ''},
							{label: 'Author', value: data.author},
							{label: 'Publisher', value: publisher},
							{label: 'ISBN', value: ISBN}
						];

					}else if(data.category_id.id == "4"){
						let platforms = [];
						if(data.platforms != null){
							platforms = data.platforms;
						}
						detail_labels = [
							{label: 'Platform', value: platforms}, 
							{label: 'Genre', value: (data.genre_id != null) ? data.genre_id.name : ''},
							{label: 'ESRB Rating', value: data.rating}, 
							{label: 'Release Date', value: (data.release_date_id != null) ? data.year : ''},
							{label: 'Developer', value: data.author},
						];

					}else if(data.category_id.id == "5"){
						detail_labels = [
							{label: 'Genre', value: (data.genre_id != null) ? data.genre_id.name : ''},
							{label: 'Rating', value: data.rating},
							{label: 'Release Date', value: (data.release_date_id != null) ? data.year : ''},
							{label: 'Network', value: data.studio}
						];
					}

					let btn_list = [];
					let new_btn ={};
					if(data.itunes_url != null) {
						new_btn.label = 'iTunes';
						new_btn.url = data.itunes_url;
						btn_list.push(new_btn);
					}
					if(data.google_play_url != null) {
						new_btn={}
						new_btn.label = 'Google Play';
						new_btn.url = data.google_play_url;
						btn_list.push(new_btn);

					}
					if(data.website_url != null) {
						new_btn={}
						new_btn.label = 'Website';
						new_btn.url = data.website_url;
						btn_list.push(new_btn);
					}
					data.activity_up_faves = data.activity.up_faves;
					data.activity_down_faves = data.activity.down_faves;
					data.activity_sends = data.activity.sends;
					data.activity_adds_to_list = data.activity.adds_to_list;
					data.activity_bucket = data.activity.bucket;

					if(data.image_url != null && data.image_url != ""){
						data.background_image_url = "url('"+data.image_url+"')";
					}else{
						data.background_image_url =  "url(/assets/img/placeholderAlbum.png)";
					}					

					let source_url = data.source_url;
					let separator = "/";
					let arraySource = source_url.split(separator);
					data.domain=arraySource[2];
					
					this.setState({
						item: data,
						btn_list,
						detail_labels
					});						
				}.bind(this)
			)
			.onError(
				function (xhr) {
					const errors = {};
					errors.message = xhr.responseJSON.error.message;
					errors.code = xhr.responseJSON.error.code;				

					this.setState({
						errors
					});				
					
				}.bind(this)
			)
			.onComplete(
				function () {

				}.bind(this)
			);
	}

	getReviews(id, filter_review){
		Reviews.GetReviews(id, filter_review)
			.onSuccess(
				function (data) {
					let messages = this.state.messages;				
					if(data.length == 0){
						messages.review = 'The item has no Reviews';
					}

					let count_reviews = data.length;					
					for (let i = 0; i < data.length; i++) {
						if(data[i].user_id.image_url != null && data[i].user_id.image_url != ""){
							data[i].user_img_url = "url("+data[i].user_id.image_url+")";
						}else{
							data[i].user_img_url =  "url(/assets/img/default.png)";
						}

						let date = new Date(data[i].create_time);
						data[i].day_review = moment(date).format('DD');
						data[i].month_review = moment(date).format('MMM');
						data[i].year_review = moment(date).format('YYYY');	
					}	

					this.setState({
						reviews: data,
						count_reviews,
						messages
					});	
				}.bind(this)
			)
			.onError(
				function (xhr) {
					const errors = {};
					errors.message = xhr.responseJSON.error.message;
					errors.code = xhr.responseJSON.error.code;				

					this.setState({
						errors
					});				
					
				}.bind(this)
			)
			.onComplete(
				function () {
					this.toggleLoadingModal(false);
					this.setState({
						isLoading: false
					});
				}.bind(this)
			);
	}

	getUserActivity(id){
		Items.GetUserActivity(id)
			.onSuccess(
				function (data) {
					let messages = this.state.messages;				
					if(data.length == 0){
						messages.activity = 'The item has no Activity';
					}
					for (let i = 0; i < data.length; i++) {
						if(data[i].image_url != null && data[i].image_url != ""){
							data[i].activity_image_url = "url("+data[i].image_url+")";
						}else{
							data[i].activity_image_url =  "url(/assets/img/default.png)";
						}						
					}					

					this.setState({
						userActivity: data,
						messages
					});	
				}.bind(this)
			)
			.onError(
				function (xhr) {
					const errors = {};
					errors.message = xhr.responseJSON.error.message;
					errors.code = xhr.responseJSON.error.code;				

					this.setState({
						errors
					});				
					
				}.bind(this)
			)
			.onComplete(
				function () {

				}.bind(this)
			);
	}

	readMore(){
		document.getElementById('div-ellipsis').style.display = 'none';
		document.getElementById('div-complete').style.display = 'inline';
		
	}

	readLess(){
		document.getElementById('div-ellipsis').style.display = 'inline';
		document.getElementById('div-complete').style.display = 'none';
	}

	toggleWriteReviewModal(status){
		this.setState({
			show_write_review_modal: status
		});
	}

	toggleLoadingModal(status){
		this.setState({
			show_loading_modal: status
		});
	}

	/**
	 * Render the component.
	 */
	render() {
		return (
			<div>
				<DetailItemView
					item = {this.state.item}
					reviews = {this.state.reviews}
					count_reviews = {this.state.count_reviews}
					userActivity = {this.state.userActivity}
					customStyles = {this.state.customStyles}
					reviews_options = {this.state.reviews_options}
					filter_review = {this.state.filter_review}
					select_review = {this.state.select_review}
					messages = {this.state.messages}
					btn_list = {this.state.btn_list}
					readMore = {this.readMore}
					readLess = {this.readLess}
					onChange = {this.onChange}
					toggleWriteReviewModal = {this.toggleWriteReviewModal}
					toggleLoadingModal = {this.toggleLoadingModal}
					onChangeSelect = {this.onChangeSelect}
					isLoading = {this.state.isLoading}
					detail_labels = {this.state.detail_labels}
				/>
				<WriteReviewModal
					show_write_review_modal = {this.state.show_write_review_modal}
					toggleWriteReviewModal = {this.toggleWriteReviewModal}
				/>

				<LoadingModal
					show_loading_modal = {this.state.show_loading_modal}
					toggleLoadingModal = {this.toggleLoadingModal}
				/>
			</div>
		);
	}

}



// WEBPACK FOOTER //
// ./src/client/components/items/DetailItemComponent.js